export default __webpack_public_path__ + "c5af8d9ec045260f7044ad88dd811027.jpg";